import { useCallback, useContext, useRef } from 'react';
import { ScrollIntoViewContext } from './scroll-into-view-context';
const DEFAULT_DELAY_MS = 300;
export function useScrollIntoView(delay) {
  if (delay === void 0) {
    delay = DEFAULT_DELAY_MS;
  }
  const {
    enabled,
    scrollToElement
  } = useContext(ScrollIntoViewContext);
  const headerRef = useRef(null);
  const contentRef = useRef(null);
  const scrollWithDelay = useCallback(() => {
    if (!enabled || !headerRef.current) {
      return;
    }
    setTimeout(() => {
      scrollToElement(headerRef.current, contentRef.current);
    }, delay);
  }, [enabled, scrollToElement, delay]);
  return {
    contentRef,
    headerRef,
    scrollWithDelay
  };
}
//# sourceMappingURL=use-scroll-into-view.js.map